import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useAlert } from "react-alert";
import {
  Box, Paper, TextField, Button, Typography, Table, TableHead, TableBody,
  TableRow, TableCell, IconButton, Dialog, DialogTitle, DialogContent,
  DialogActions, Select, MenuItem, FormControl, InputLabel, Chip, Switch,
  FormControlLabel, Tooltip, Alert, ToggleButton, ToggleButtonGroup
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Menu from "../../Menu";
import Header from "../../Header";
import { FormsApi, WHATSAPP_VAR_SOURCES } from "../formsUtils";
import { errorMessage } from "../../../services/http";

const emptyTemplate = { name: "", kind: "content", content_sid: "", body: "", service_sid: "", variables_map: [], active: true };

/** variables_map vem do banco; um valor malformado não pode derrubar a tela inteira. */
function parseVars(valor) {
  if (typeof valor !== "string") return valor || [];
  try {
    return JSON.parse(valor) || [];
  } catch (e) {
    return [];
  }
}

export default function WhatsAppConfig() {
  const alert = useAlert();
  const history = useHistory();
  const [settings, setSettings] = useState({ account_sid: "", auth_token: "", service_sid: "", status_callback_url: "", has_auth_token: false });
  const [templates, setTemplates] = useState([]);
  const [dialog, setDialog] = useState({ open: false, template: emptyTemplate, editing: null });

  function loadSettings() {
    FormsApi.getWhatsappSettings().then(
      (resp) => { if (resp?.data?.data) setSettings({ ...resp.data.data, auth_token: "" }); },
      () => {}
    );
  }
  function loadTemplates() {
    FormsApi.listTemplates().then((resp) => setTemplates(resp?.data?.data || []), () => {});
  }
  useEffect(() => { loadSettings(); loadTemplates(); }, []);

  function saveSettings() {
    const payload = {
      account_sid: settings.account_sid,
      service_sid: settings.service_sid,
      status_callback_url: settings.status_callback_url,
    };
    if (settings.auth_token) payload.auth_token = settings.auth_token; // só envia se preenchido
    FormsApi.saveWhatsappSettings(payload).then(
      () => { alert.success("Configuração salva!"); loadSettings(); },
      (error) => alert.error(errorMessage(error, "Erro ao salvar"))
    );
  }

  function openNew() { setDialog({ open: true, template: { ...emptyTemplate, variables_map: [] }, editing: null }); }
  function openEdit(t) {
    setDialog({ open: true, editing: t.id, template: {
      name: t.name, kind: t.kind || "content", content_sid: t.content_sid || "", body: t.body || "",
      service_sid: t.service_sid || "",
      variables_map: parseVars(t.variables_map),
      active: t.active,
    }});
  }
  function saveTemplate() {
    const t = dialog.template;
    if (!t.name) { alert.error("Informe o nome do template"); return; }
    if (t.kind === "body" ? !t.body : !t.content_sid) {
      alert.error(t.kind === "body" ? "Informe o corpo da mensagem" : "Informe o Content SID");
      return;
    }
    const req = dialog.editing
      ? FormsApi.updateTemplate(dialog.editing, t)
      : FormsApi.createTemplate(t);
    req.then(
      () => { setDialog({ open: false, template: emptyTemplate, editing: null }); loadTemplates(); alert.success("Template salvo!"); },
      (error) => alert.error(errorMessage(error, "Erro ao salvar template"))
    );
  }
  function removeTemplate(t) {
    if (!window.confirm(`Remover template "${t.name}"?`)) return;
    FormsApi.deleteTemplate(t.id).then(() => loadTemplates());
  }

  const tpl = dialog.template;
  const setTpl = (patch) => setDialog((d) => ({ ...d, template: { ...d.template, ...patch } }));
  const vars = tpl.variables_map || [];
  const updateVar = (i, patch) => setTpl({ variables_map: vars.map((v, idx) => (idx === i ? { ...v, ...patch } : v)) });
  const addVar = () => setTpl({ variables_map: [...vars, { index: String(vars.length + 1), source: "first_name", value: "" }] });
  const removeVar = (i) => setTpl({ variables_map: vars.filter((_, idx) => idx !== i) });

  return (
    <div id="wrapper">
      <Menu />
      <div id="page-wrapper" className="gray-bg">
        <Header />
        <div className="row wrapper border-bottom white-bg page-heading">
          <div className="col-lg-12">
            <Button startIcon={<ArrowBackIcon />} onClick={() => history.push("/forms")}>Voltar</Button>
            <h2 style={{ marginTop: 8 }}>Configuração de WhatsApp</h2>
          </div>
        </div>

        <div className="wrapper wrapper-content animated fadeInRight">
          <div className="row"><div className="col-lg-12">

            <Paper variant="outlined" sx={{ p: 3, mb: 3 }}>
              <Typography variant="h6" sx={{ mb: 2 }}>Conta Twilio</Typography>
              <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                <TextField label="Account SID" sx={{ minWidth: 320 }} value={settings.account_sid || ""}
                  onChange={(e) => setSettings({ ...settings, account_sid: e.target.value })} />
                <TextField label="Auth Token" type="password" sx={{ minWidth: 320 }}
                  placeholder={settings.has_auth_token ? "•••••• (preencha para alterar)" : ""}
                  value={settings.auth_token || ""}
                  onChange={(e) => setSettings({ ...settings, auth_token: e.target.value })} />
                <TextField label="Service SID / Número origem" sx={{ minWidth: 320 }}
                  value={settings.service_sid || ""}
                  onChange={(e) => setSettings({ ...settings, service_sid: e.target.value })}
                  placeholder="ex.: whatsapp:+551130355202 ou MG..."
                  helperText="Obrigatório para envio (a menos que cada template defina o seu). Usado como padrão quando o template deixa o campo vazio." />
                <TextField label="URL de status callback (webhook)" sx={{ minWidth: 460 }}
                  helperText="Ex.: https://SEU-API/takaokabots/public/forms/whatsapp/status"
                  value={settings.status_callback_url || ""}
                  onChange={(e) => setSettings({ ...settings, status_callback_url: e.target.value })} />
              </Box>
              <Button variant="contained" sx={{ mt: 2 }} onClick={saveSettings}>Salvar configuração</Button>
            </Paper>

            <Paper variant="outlined" sx={{ p: 3 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <Typography variant="h6">Templates de mensagem</Typography>
                <Button variant="outlined" startIcon={<AddIcon />} onClick={openNew}>Novo template</Button>
              </Box>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Nome</TableCell>
                    <TableCell>Content SID</TableCell>
                    <TableCell>Variáveis</TableCell>
                    <TableCell>Ativo</TableCell>
                    <TableCell align="right">Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {templates.map((t) => {
                    const vmap = parseVars(t.variables_map);
                    return (
                      <TableRow key={t.id}>
                        <TableCell>{t.name}</TableCell>
                        <TableCell><code>{t.content_sid}</code></TableCell>
                        <TableCell>{vmap.length}</TableCell>
                        <TableCell>{t.active ? <Chip size="small" label="Sim" color="success" /> : <Chip size="small" label="Não" />}</TableCell>
                        <TableCell align="right">
                          <Tooltip title="Editar"><IconButton size="small" onClick={() => openEdit(t)}><EditIcon fontSize="small" /></IconButton></Tooltip>
                          <Tooltip title="Remover"><IconButton size="small" color="error" onClick={() => removeTemplate(t)}><DeleteIcon fontSize="small" /></IconButton></Tooltip>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {templates.length === 0 && (
                    <TableRow><TableCell colSpan={5} align="center" style={{ color: "#999", padding: 24 }}>
                      Nenhum template cadastrado.
                    </TableCell></TableRow>
                  )}
                </TableBody>
              </Table>
            </Paper>

          </div></div>
        </div>
      </div>

      <Dialog open={dialog.open} onClose={() => setDialog({ ...dialog, open: false })} maxWidth="md" fullWidth>
        <DialogTitle>{dialog.editing ? "Editar template" : "Novo template"}</DialogTitle>
        <DialogContent>
          <ToggleButtonGroup size="small" exclusive value={tpl.kind || "content"} sx={{ mt: 1, mb: 1 }}
            onChange={(_, v) => v && setTpl({ kind: v })}>
            <ToggleButton value="content">Template aprovado (Content SID)</ToggleButton>
            <ToggleButton value="body">Mensagem de texto (corpo)</ToggleButton>
          </ToggleButtonGroup>


          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: 1 }}>
            <TextField label="Nome" value={tpl.name} onChange={(e) => setTpl({ name: e.target.value })}
              sx={{ minWidth: 240 }} autoComplete="off" inputProps={{ autoComplete: "off" }} />
            {tpl.kind !== "body" && (
              <TextField label="Content SID (HX...)" value={tpl.content_sid}
                onChange={(e) => setTpl({ content_sid: e.target.value })} sx={{ minWidth: 280 }}
                autoComplete="off" inputProps={{ autoComplete: "off" }}
                helperText="Só o identificador HX..., não o texto" />
            )}
            <TextField label="Service SID / número (opcional)" value={tpl.service_sid}
              onChange={(e) => setTpl({ service_sid: e.target.value })} sx={{ minWidth: 300 }}
              autoComplete="off" inputProps={{ autoComplete: "off" }}
              placeholder="ex.: whatsapp:+551130355202"
              helperText="Opcional no template: vazio usa o padrão de Conta Twilio (acima). Preencha só para sobrescrever neste template." />
          </Box>

          {tpl.kind === "body" && (
            <TextField label="Corpo da mensagem" fullWidth multiline rows={5} sx={{ mt: 2 }}
              value={tpl.body} onChange={(e) => setTpl({ body: e.target.value })}
              placeholder={"Olá {{1}}! Preencha o questionário: {{2}}"}
              helperText="Use {{1}}, {{2}}, ... e mapeie cada posição abaixo. Atenção: no WhatsApp, mensagem de texto livre só é entregue dentro da janela de 24h; envio em massa (cold) exige template aprovado." />
          )}

          <FormControlLabel sx={{ mt: 1 }}
            control={<Switch checked={!!tpl.active} onChange={(e) => setTpl({ active: e.target.checked })} />} label="Ativo" />

          <Alert severity="info" sx={{ my: 2 }}>
            Mapeie cada variável (posição 1, 2, ...) para uma fonte de dados.
            Use <strong>Link do formulário</strong> na variável que contém a URL.
          </Alert>

          {vars.map((v, i) => (
            <Box key={i} sx={{ display: "flex", gap: 1, mb: 1, alignItems: "center" }}>
              <TextField label="Posição" sx={{ width: 90 }} value={v.index}
                onChange={(e) => updateVar(i, { index: e.target.value.replace(/[^0-9]/g, "") })} />
              <FormControl sx={{ minWidth: 240 }}>
                <InputLabel>Fonte</InputLabel>
                <Select label="Fonte" value={v.source} onChange={(e) => updateVar(i, { source: e.target.value })}>
                  {WHATSAPP_VAR_SOURCES.map((s) => <MenuItem key={s.value} value={s.value}>{s.label}</MenuItem>)}
                </Select>
              </FormControl>
              {v.source === "custom" && (
                <TextField label="Texto fixo" value={v.value || ""} onChange={(e) => updateVar(i, { value: e.target.value })} sx={{ flex: 1 }} />
              )}
              <IconButton size="small" color="error" onClick={() => removeVar(i)}><DeleteIcon fontSize="small" /></IconButton>
            </Box>
          ))}
          <Button size="small" startIcon={<AddIcon />} onClick={addVar}>Adicionar variável</Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialog({ ...dialog, open: false })}>Cancelar</Button>
          <Button variant="contained" onClick={saveTemplate}>Salvar</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
